// La policy password del pool Cognito, in un posto solo.
//
// ⛔ Questi numeri NON sono una scelta di prodotto: sono la configurazione viva
// del pool (`MinimumLength: 10`, maiuscola + minuscola + numero, simboli NON
// richiesti), letta interrogandolo l'1/09. Se la policy del pool cambia, questo
// file la insegue — non il contrario. Un client più severo del server rifiuta
// password che Cognito accetterebbe; un client più permissivo manda l'atleta a
// sbattere contro un errore inglese del provider, che è il difetto che questo
// file esiste per togliere (`InvalidPasswordException` non è tradotto).
//
// Perché in `shared` e non dentro il form: la stessa regola serve già in due
// punti dell'albero — il form di benvenuto (PROF-3) e il cambio password
// (`apps/mobile/src/screens/ChangePasswordCard.tsx:33`, che oggi controlla solo
// `length >= 10` e lascia passare il resto). Il secondo chiamante si adotta
// passando di lì, ed è registrato in `next/consolidation.md`.

/** Regole che una password può non soddisfare. Nomi = chiavi i18n a valle. */
export type PasswordRule = "length" | "uppercase" | "lowercase" | "number";

export const PASSWORD_MIN_LENGTH = 10;

/**
 * Le regole NON soddisfatte, in ordine stabile. Vuoto = la password passa.
 *
 * ⭐ Restituisce l'elenco invece di un booleano di proposito: un campo che dice
 * solo «non va bene» costringe a indovinare, e la copia che spiega la policy
 * (`auth.passwordHint`) esiste già tradotta in cinque lingue. Chi chiama può
 * mostrare l'hint intero o solo la riga che manca.
 */
export const unmetPasswordRules = (password: string): PasswordRule[] => {
  const unmet: PasswordRule[] = [];
  if (password.length < PASSWORD_MIN_LENGTH) unmet.push("length");
  if (!/[A-Z]/.test(password)) unmet.push("uppercase");
  if (!/[a-z]/.test(password)) unmet.push("lowercase");
  if (!/[0-9]/.test(password)) unmet.push("number");
  return unmet;
};

export const passwordMeetsPolicy = (password: string): boolean =>
  unmetPasswordRules(password).length === 0;
